import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import StaticApp from './App.static';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StaticApp />
  </React.StrictMode>
);
